import constants from 'helper/constants';
import React, { PureComponent } from 'react';
import Loading from 'modules/Loading';

class SdkExit extends PureComponent {
  constructor(props) {
    super(props);

    this.api = this.props.api;
    this.user = this.props.user;
    this.sdk = this.props.sdk;
    this.fromLink = this.props.fromLink;
  }

  componentDidMount() {
    this.sdk.transferToken(this.api.token);
    this.sdk.applyPersonalization((status) => {
      if (status === constants.sdk.success) {
        this.sdk.userUpdate(this.user, (userUpdateCallback) => {
          if (userUpdateCallback === constants.sdk.success) {
            this.sdk.returnFromUserAccountPortal();
            this.sdk.exit();
          } else {
            // eslint-disable-next-line
            console.error('userUpdate method failed after sign-in');
          }
        });
      }
    });
  }
  render() {
    return (
      <div>
        <Loading />
      </div>
    );
  }
}

export default SdkExit;



// WEBPACK FOOTER //
// ./src/modules/signup/SdkExit.jsx